import { useState, useEffect } from "react";

import { listWabaTemplates } from "../../../services/wabaTemplates.api";
import toastError from "../../../errors/toastError";

// FSD (0322): capa de datos separada de la presentación. Carga las plantillas HSM
// APPROVED de una conexión WABA para el mapeo en campañas (0369 HC5).
export default function useCampaignTemplates(whatsappId) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!whatsappId) {
      setTemplates([]);
      return;
    }
    setLoading(true);
    listWabaTemplates({ whatsappId, status: "APPROVED" })
      .then(({ data }) => setTemplates(Array.isArray(data) ? data : []))
      .catch(toastError)
      .finally(() => setLoading(false));
  }, [whatsappId]);

  return { templates, loading };
}
